import React from "react"
import { Dashboard } from "../components/dashboard"
import { QuizInterface } from "../components/quiz-interface"
import { useQuiz } from "../hooks/use-quiz"
import { useAuth } from "../contexts/auth-context"
import type { Exam, Question } from "../types/quiz"

export default function HomePage() {
  const { session, userProgress, startQuiz, answerQuestion, nextQuestion, resetQuiz, resultsSaved } = useQuiz()
  const { isAuthenticated } = useAuth()

  const handleStartExam = (exam: Exam) => {
    if (!isAuthenticated) {
      // This shouldn't happen since exams are gated, but just in case
      return
    }
    startQuiz(exam.questions, "exam", exam.id)
  }

  const handleStartRandom = (questions: Question[]) => {
    startQuiz(questions, "random")
  }

  const handleQuizBack = () => {
    resetQuiz()
  }

  if (session) {
    return (
      <QuizInterface
        session={session}
        onAnswer={answerQuestion}
        onNext={nextQuestion}
        onBack={handleQuizBack}
        resultsSaved={resultsSaved}
      />
    )
  }

  return <Dashboard userProgress={userProgress} onStartExam={handleStartExam} onStartRandom={handleStartRandom} />
}
